export const LOCIZE_PROJECT_ID = process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID ?? '';

export const LOCIZE_VERSION = 'latest';

export const IS_CDN_ENABLED = process.env.NEXT_PUBLIC_ENV === 'development';
